import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {Observable, throwError} from 'rxjs';
import {CustomsValidators} from '../../validators/custom.validators';

@Injectable({
  providedIn: 'root'
})
export class SelfVerificationService {
  myAccessesURL: string;
  myAccessesDetailURL: string;
  myQualificationUrl: string;
  searchExternal: string;
  searchVisitor: string;
  authorisedAccessesSelfCheck: string;
  authorisedVisitorAccessesSelfCheck: string;
  qualificationsSelfCheck: string;

  constructor(private http: HttpClient) {
    this.myAccessesURL = `${environment.bffBaseUrl}/pages/self-verifications/`;
    this.myAccessesDetailURL = `${environment.bffBaseUrl}/pages/self-verifications/`;
    this.myQualificationUrl = `${environment.bffBaseUrl}/pages/my-qualifications/`;
    this.searchExternal = `${environment.bffBaseUrl}/pages/SelfCheckThirdParties/GetPeopleSelfCheck/`;
    this.searchVisitor = `${environment.bffBaseUrl}/pages/SelfCheckThirdParties/GetVisitorSelfCheck/`;
    this.authorisedAccessesSelfCheck = `${environment.bffBaseUrl}/pages/self-verifications/AuthorisedAccessesSelfCheck/`;
    this.authorisedVisitorAccessesSelfCheck = `${environment.bffBaseUrl}/pages/self-verifications/AuthorisedVisitorAccessesSelfCheck/`;
    this.qualificationsSelfCheck = `${environment.bffBaseUrl}/pages/my-qualifications/QualificationsSelfCheck/`;

  }

  getMyAccesses(): Observable<any> {
    const urlBuilder = this.myAccessesURL;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getMyAccessesDetail(requestNumber): Observable<any> {
    const urlBuilder = this.myAccessesDetailURL + requestNumber;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getMyQualifications(): Observable<any> {
    const urlBuilder = this.myQualificationUrl;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getSearchExternal(search): Observable<any> {
    const urlBuilder = this.searchExternal + search;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }
  getSearchVisitor(search): Observable<any> {
    const urlBuilder = this.searchVisitor + search;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  } 
  getSearchVisitorbyMailRut(email, rut): Observable<any> {
    const urlBuilder = this.searchVisitor + email+"/"+rut;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getSearchExternalMailRut(email, rut): Observable<any> {
    const urlBuilder = this.searchExternal + email+"/"+rut;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getAuthorisedAccessesSelfCheck(mdmid): Observable<any> {
    const urlBuilder = this.authorisedAccessesSelfCheck + mdmid;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }
  getAuthorisedVisitorAccessesSelfCheck(email,rut): Observable<any> {
    const urlBuilder = this.authorisedVisitorAccessesSelfCheck + email+"/"+rut;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getQualificationsSelfCheck(mdmid): Observable<any> {
    const urlBuilder = this.qualificationsSelfCheck + mdmid;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }


}
